<template>
  <el-dialog
    class="dialog"
    title="新增成绩"
    fullscreen
    :visible.sync="dialogVisible"
    v-if="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
    destroy-on-close
  >
    <div>
      <div class="exam-title">试卷名称：{{ examPaperInfo.paperName }}</div>
      <div class="exam-score">(满分：{{ examPaperInfo.totalScore }}分)</div>
      <div class="info-panel">
        <div class="info-left">
          <div class="submitTime">提交时间：
            <el-date-picker
              size="small"
              v-model="submitTime"
              type="datetime"
              placeholder="请选择提交时间"
              format="yyyy-MM-dd HH:mm"
              @change="dateOptions"
            >
            </el-date-picker>
          </div>
          <div class="info-date" v-if="examPaperInfo.limitStartTime">考试时间：{{
              examPaperInfo.limitStartTime + " - " + examPaperInfo.limitEndTime
            }}</div>
          <div class="info-date" v-if="!examPaperInfo.limitStartTime && examPaperInfo.publishDate">发布时间：{{
              examPaperInfo.publishDate
            }}</div>
          <!--<div class="info-date" v-if="examPaperInfo.reexamStartTime"
            >补考时间：{{
              examPaperInfo.reexamStartTime +
                " - " +
                examPaperInfo.reexamEndTime
            }}</div>-->
        </div>
        <table>
          <tr>
            <th class="t-head">得分</th>
            <th class="t-head">答对</th>
            <th class="t-head">答错</th>
          </tr>
          <tr>
            <th class="t-body">{{ examPaperInfo.examScore }}</th>
            <th class="t-body">{{ examPaperInfo.rightNum }}</th>
            <th class="t-body">{{ examPaperInfo.wrongNum }}</th>
          </tr>
        </table>
      </div>
    </div>
    <div class="paper">
      <template v-if="examPaperInfo.singleQstCount > 0">
        <div class="exam-category">
          单选题(每题{{ examPaperInfo.singleQstScore }}分,共{{
            examPaperInfo.singleQstCount
          }}题)
        </div>
        <questions
          type="add"
          :datas="examPaperInfo.singleQstList"
          @answerChanged="handleScore($event, examPaperInfo.singleQstScore)"
        ></questions>
      </template>
      <template v-if="examPaperInfo.multipleQstCount > 0">
        <div class="exam-category">
          多选题(每题{{ examPaperInfo.multipleQstScore }}分,共{{
            examPaperInfo.multipleQstCount
          }}题)
        </div>
        <questions
          type="add"
          multiple
          :datas="examPaperInfo.multipleQstList"
          @answerChanged="handleScore($event, examPaperInfo.multipleQstScore)"
        ></questions>
      </template>
      <template v-if="examPaperInfo.judgeQstCount > 0">
        <div class="exam-category">
          判断题(每题{{ examPaperInfo.judgeQstScore }}分,共{{
            examPaperInfo.judgeQstCount
          }}题)
        </div>
        <questions
          type="add"
          :datas="examPaperInfo.judgeQstList"
          @answerChanged="handleScore($event, examPaperInfo.judgeQstScore)"
        ></questions>
      </template>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取消</el-button>
      <el-button type="primary" size="small" @click="submit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import vue from "@/main";
import { ExamInfoManual, ExamInfoManualSubmit } from "@/api/examInfo";
import Questions from "@/views/questions";
import moment from "moment";
export default {
  components: {
    Questions
  },
  data() {
    return {
      dialogVisible: false,
      examPaperInfo: {},
      submitTime: "",
    };
  },
  created() {
    vue.$on("addScore", id => {
      this.dialogVisible = true;
      ExamInfoManual(id).then(res => {
        if (!res || res.code != 0) return;
        let obj = Object.assign({}, res.data);
        this.submitTime = "";
        if (obj.singleQstList) {
          obj.singleQstList.map(ele => {
            for (const item in ele.optionList) {
              if (ele.optionList[item].isCorrectAnswer) {
                ele["correctAnswer"] = ele.optionList[item].optionNo;
                ele["userAnswer"] = ele.optionList[item].optionNo;
                break;
              }
            }
            return ele;
          });
        }
        if (obj.judgeQstList) {
          obj.judgeQstList.map(ele => {
            for (const item in ele.optionList) {
              if (ele.optionList[item].isCorrectAnswer) {
                ele["correctAnswer"] = ele.optionList[item].optionNo;
                ele["userAnswer"] = ele.optionList[item].optionNo;
                break;
              }
            }
            return ele;
          });
        }
        if (obj.multipleQstList) {
          obj.multipleQstList.map(ele => {
            let array = [];
            ele.optionList.forEach(item => {
              if (item.isCorrectAnswer) {
                array.push(item.optionNo);
              }
            });
            ele["correctAnswer"] = [...array];
            ele["userAnswer"] = [...array];
            return ele;
          });
        }
        this.examPaperInfo = obj;
      });
    });
  },
  watch: {
    examPaperInfo() {
      this.$nextTick(() => {
        let doms = document.getElementsByClassName("exam-category");
        for (let index = 0; index < doms.length; index++) {
          const element = doms[index];
          element.innerText =
            this.mapNum2Chinese(index + 1) + "、" + element.innerText;
        }
      });
    }
  },
  beforeDestroy() {
    vue.$off("addScore");
  },
  methods: {
    mapNum2Chinese(num) {
      switch (num) {
        case 1:
          return "一";
        case 2:
          return "二";
        case 3:
          return "三";
        default:
          break;
      }
    },
    dateOptions(date) {
      let flag = true;
      if (this.examPaperInfo.limitStartTime) {
        if ((moment(this.examPaperInfo.limitStartTime).valueOf() > date.getTime()) || (moment(this.examPaperInfo.limitEndTime).valueOf() < date.getTime())) {
          this.$message.warning("提交时间可选时间范围区间（考试开始时间，考试结束时间）");
          flag = false;
        }
      } else if (!this.examPaperInfo.limitStartTime && this.examPaperInfo.publishDate){
        if (moment(this.examPaperInfo.publishDate).valueOf() > date.getTime()) {
          this.$message.warning("提交时间须晚于发布时间");
          flag = false;
        }
      }
      return flag;
    },
    handleScore(flag, score) {
      if (flag) {
        this.examPaperInfo.examScore += score;
        this.examPaperInfo.rightNum++;
        this.examPaperInfo.wrongNum--;
      } else {
        this.examPaperInfo.examScore -= score;
        this.examPaperInfo.rightNum--;
        this.examPaperInfo.wrongNum++;
      }
    },
    submit() {
      if (this.submitTime.length === 0) {
        this.$message({
          message: "请选择提交时间",
          type: "warning"
        });
        return;
      }
      let flag = this.dateOptions(this.submitTime);
      if (!flag) return;
      let questionAnswerMap = {};
      if (this.examPaperInfo.singleQstList) {
        this.examPaperInfo.singleQstList.forEach(ele => {
          questionAnswerMap[ele.questionId] = ele.userAnswer;
        });
      }
      if (this.examPaperInfo.multipleQstList) {
        this.examPaperInfo.multipleQstList.forEach(ele => {
          questionAnswerMap[ele.questionId] = ele.userAnswer.join(",");
        });
      }
      if (this.examPaperInfo.judgeQstList) {
        this.examPaperInfo.judgeQstList.forEach(ele => {
          questionAnswerMap[ele.questionId] = ele.userAnswer;
        });
      }
      let params = {
        batchId: this.examPaperInfo.batchId,
        submitTime: moment(this.submitTime).format("YYYY-MM-DD HH:mm"),
        questionAnswerMap
      };
      ExamInfoManualSubmit(params).then(res => {
        if (!res || res.code != 0) return;
        this.$message({ message: "新增成绩成功", type: "success" });
        this.close();
        this.$emit("addScoreSuccess");
      });
    },
    close() {
      this.dialogVisible = false;
      this.examTime = [];
    }
  }
};
</script>

<style lang="scss" scoped>
$color: #343c4a;
$text-size: 14px;
.dialog {
  /deep/ .el-dialog.is-fullscreen {
    overflow: hidden;
  }
  /deep/ .el-dialog__body {
    max-height: calc(100% - 117px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 10px 20px;
  }
  .exam-title {
    font-size: 20px;
    color: $color;
    text-align: center;
  }
  .exam-score {
    font-size: $text-size;
    color: $color;
    text-align: center;
    margin: 10px 0;
  }
  .info-panel {
    display: flex;
    align-items: center;
    margin: 20px 0;
    .info-left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: $color;
      font-size: $text-size;
      width: 32%;
      .submitTime {
        display: flex;
        align-items: center;
      }
      .info-date {
        margin-top: 10px;
        color: $color;
        font-size: 13px;
      }
    }
    table {
      border-collapse: collapse;
    }
    table,
    th {
      border: 1px solid #d7dbe0;
    }
    th {
      padding: 10px 20px;
      &.t-head {
        color: #96a1b2;
        font-size: $text-size;
      }
      &.t-body {
        color: $color;
        font-size: $text-size;
      }
    }
  }
  .paper {
    flex: 1;
    overflow: auto;
    padding: 0;
    .exam-category {
      font-size: 15px;
      font-weight: 500;
      color: $color;
    }
  }
  .dialog-footer {
    text-align: center;
  }
}
</style>
